export default {
    buttons: {
        search: 'Vyhledat',
        choose: 'Vybrat',
        chosen: 'Vybráno',
        close: 'Zavřít',
        show: 'Zobrazit',
        save: 'Uložit',
    },

    property_type: {
        unit: 'Jednotka',
        building: 'Stavba',
        parcel: 'Parcela',
        flat: 'Byt',
        family_house: 'Rodinný dům',
        recreational: 'Rekreační objekt',
        apartment_house: 'Bytový dům',
        hut: 'Chata',
        cottage: 'Chalupa',
        land: 'Pozemek',
    },

    data: {
        all_data: 'Všechny údaje',
        purchased_only: 'Pouze zakoupené',
    },

    parameters: {
        district: 'Okres',
        village: 'Obec',
        cadastre_area: 'Katastrální území',
        period: 'Období',
        unit_usage: 'Způsob využití jednotky',
        building_usage: 'Způsob využití budovy',
        land_type: 'Druh pozemku',
        share_area: 'Plocha dle podílu',
        parcel_under: 'Parcela pod budovou',
        parcel_area: 'Plocha parcely',
        land_area: 'Plocha pozemku',
        by_pairing: 'Dle napárování',
        paired: 'Napárované',
        to_pair: 'K napárování',
        without_candidates: 'Bez kandidátů',
        area_size: 'Velikost oblasti',
        countable_area: 'Započitatelná plocha',
        age: 'Stáří',


        form: {
            names: {
                ownership: "Vlastnictví",
                disposition: "Dispozice",
                construction: "Konstrukce",
                floor: "Podlaží bytu",
                total_floors: "Celkem podlaží",
                rating: "Stav nemovitosti",
                land_type: "Typ pozemku",
                building_type: "Typ stavebního objektu",
                subcategory: "Podkategorie",
                construction_quality: "Kvalita provedení stavby",
            },

            rating: {
                bad: 'Neobyvatelný',
                nothing_much: 'Před rekonstrukcí',
                good: 'Průměrný',
                very_good: 'Velmi dobrý',
                new: 'Novostavba',
                excellent: 'Luxusní',

                help: {
                    flat: {
                        bad: 'Byt, ve kterém bez kompletní rekonstrukce není možné bydlet. Chybí koupelna i kuchyň.',
                        nothing_much: 'Je zde možné bydlet, ale koupelna i kuchyň jsou min. 25 let staré a zasloužily by si modernizaci. Jedná se např. o panelové byty s umakartovým jádrem.',
                        good: 'Kuchyň i koupelna jsou ve stavu, že je možné je bez větších úprav plně využívat. Nejsou však po kompletní rekonstrukci v posledních letech.',
                        very_good: 'Byt je po kompletní rekonstrukci (kuchyň, koupelna, okna).',
                        new: 'Běžná novostavba nebo téměř nová nemovitost. Cena by měla být podobná ostatním novostavbám v okolí.',
                        excellent: 'Jsou použity velmi drahé technologie a materiály. Cena by měla být mnohem vyšší než u běžných novostaveb v okolí.'
                    },

                    house: {
                        bad: 'Dům je určený k demolici nebo kompletní rekonstrukci (střecha, okna, fasáda, kuchyň, koupelna).',
                        nothing_much: 'Nejméně 25 let zde neproběhla žádná rekonstrukce. Modernizaci si zaslouží interiér i exteriér.',
                        good: 'Dům lze pohodlně využívat. Interiér nebo exteriér však v posledních letech neprošel žádnou rekonstrukcí.',
                        very_good: 'Dům je po kompletní rekonstrukci (střecha, okna, fasáda, kuchyň, koupelna).',
                        new: 'Běžná novostavba nebo téměř nová nemovitost. Cena by měla být podobná ostatním novostavbám v okolí.',
                        excellent: 'Jsou použity velmi drahé technologie a materiály. Cena by měla být mnohem vyšší než u běžných novostaveb v okolí.'
                    },
                },
            },

            land_type: {
                null: 'Neuvedeno',
                building: 'Stavební',
                field: 'Pole',
                garden: 'Zahrada',
                meadow: 'Louka',
                forest: 'Les',
                other: 'Jiný',
            },

            house_subtype: {
                unified_panel: 'Panelový',
                unified_other: 'Typový',
                atypical: 'Netypový',
                individual: 'Samostatný',
                semi_detached: 'Dvojdomek',
                row_house: 'Řadový',
                hut: 'Chata',
                cottage: 'Chalupa',
                help: {
                    unified_panel: 'Klasický panelový bytový dům 20. století, jehož konstrukce je montována z železobetonových prefabrikovaných dílů.',
                    unified_other: 'Bytové domy, u nichž se výstavba opakuje (mají daný typ, půdorys, který se několikrát opakuje, popřípadě je pouze lehce upraven na základě přání zákazníka). Konstrukční systém je jakýkoliv kromě panelové výstavby Např. velký developerský projekt, kde jsou použity 2 typy bytového domu, které se na parcele několikrát opakuje.',
                    atypical: 'Bytové domy, který mají jedinečný tvar a půdorys (jsou postaveny pouze jednou). Konstrukční systém je jakýkoliv kromě panelové výstavby.',
                    individual: 'Jedná se o samostatně stojící rodinný dům.',
                    semi_detached: 'Rodinný dům, který sdílí jednu společnou stěnu s vedlejším domem.',
                    row_house: 'Rodinné domy, které jsou řazeny těsně vedle sebe a sdílí nosné zdi se sousedním domem.',
                    hut: 'Stavba, která je určená k individuální rekreaci. Může být podsklepená a má nejvýše jedno nadzemní podlaží a podkroví.',
                    cottage: 'Stavba, která je určena nejen pro rekreaci, ale i pro případné celoroční bydlení.',
                }
            },

            floors: {
                basement: "Suterén",
                first_floor: "Přízemí",
                floor: "NP",
            },

            ownership: {
                null: 'Neuvedeno',
                private: 'Osobní',
                cooperative: 'Družstevní',
                council: 'Státní/obecní',
                other: 'Jiné',
            },

            local_type: {
                null: 'Neuvedeno',
                '1+kk': '1+kk',
                '1+1': '1+1',
                '2+kk': '2+kk',
                '2+1': '2+1',
                '3+kk': '3+kk',
                '3+1': '3+1',
                '4+kk': '4+kk',
                '4+1': '4+1',
                'jiné': 'jiné',
            },

            constructions: {
                null: 'Neuvedeno',
                brick: 'Cihlová',
                wood: 'Dřevěná',
                stone: 'Kamenná',
                montage: 'Montovaná',
                monolithic_bar: 'Monolitická',
                monolithic_panel: 'Panelová',
                not_specified: 'Neuvedeno',
                panel: 'Panelová',
                prefabricated: 'Montovaná',
                mixed: 'Smíšená',
                low_energy: 'Nízkonákladová',
                other: 'Jiná',
            },

            construction_quality: {
                standard: 'Standard',
                low: 'Nízký',
                high: 'Vysoký',
                very_high: 'Velmi vysoký',
                help: {
                    standard: 'Obsahuje základní prvky, <strong>žádné nadstandardní vybavení</strong>. Běžné materiály, klasické vybavení (1x koupelna a WC), klasický typ omítané fasády se zateplením. Střecha skládaná z tašek (keramické, betonové) nebo plechová.',
                    low: 'Použité materiály a vybavení stavby <strong>jsou nízké kvality</strong>. Stavba neobsahuje prvky, které jsou popsány v standardním materiálovém vybavení. Nízký standard materiálu lze poznat při vizuální prohlídce. Souvisí s kvalitou materiálů a kvalitou provedení (větší množství nedodělků, reklamací a chyb). Dále obsahuje prvky, které brání k <strong>bezproblémovému užívání stavby',
                    high: '<strong>Obsahuje některé z těchto prvků</strong>: balkon, lodžie, terasa, komora, sklepní kóje, prádelna, společné prostory. WC nebo koupelna jsou zde více jak jednou (např. 2x WC a obsahuje sprchu a vanu). Použitý <strong>materiál je nadstandardní kvality</strong> (velkoformátové obklady, designové vypínače/zásuvky, velkoformátová okna, střešní krytina z PVC folie).',
                    very_high: '<strong>Obsahuje některé prvky z předchozího standardu a navíc některý z těchto prvků</strong>: krb, sauna, bazén, centrální vysavač, podlahové topení, klimatizace, elektrické žaluzie a rolety, obklady a ozdobné prvky (kamenné obklady, pohledový beton, nerezové prvky, mozaiky, dřevěné parkety). Dále obsahuje externí vybavení objektu: solární panely, nádrže na hospodaření s dešťovou vodou, provětrávané fasády (zelené, plechové, dřevěné), střechu (zelená, měděná, šindel, břidlice, pochozí, posuvná). ',
                },
            },
        },
    },

    titles: {
        property_type: 'Typ nemovitosti',
        address: 'Adresa',
        sale_lease: 'Prodej nebo pronájem',
        more: 'Detaily nemovitosti',
        disposition: 'Dispozice',
        as_of: 'Spočítat odhad k datu',
    },

    kind: {
        sale: 'Prodej',
        lease: 'Pronájem',

        help: {
            sale: 'Chci znát aktuální obvyklou cenu této nemovitosti',
            lease: 'Chci znát aktuální obvyklou cenu za pronájem této nemovitosti',
        }
    },

    autocomplete: {
        placeholder: "Adresa nebo souřadnice ve tvaru 50.1000593, 13.4360036",
        no_result: "Nebyl nalezen žádný výsledek",
        loading: "Načítám...",
    },

    disposition: {
        floor_area: "Podlahová plocha",
        lot_area: "Plocha pozemku",
        balcony: "Balkón + Lodžie + Terasa",
        garden: "Vlastní zahrada",
        cellar: "Sklep",
        garage: "Garáž",
        other_area: "Neobyvatelná plocha",

        help: {
            floor_area_other: 'Podlahovou plochou je ve Valuo oproti Nařízení vlády č. 366/2013 Sb. myšlen součet všech místností BEZ všech svislých nosných i nenosných konstrukcí uvnitř objektu, jako jsou stěny, sloupy, pilíře, komíny a obdobné svislé konstrukce.',
            floor_area_flat: 'Podlahovou plochou je ve Valuo oproti Nařízení vlády č. 366/2013 Sb. myšlen součet všech místností BEZ všech svislých nosných i nenosných konstrukcí uvnitř bytu, jako jsou stěny, sloupy, pilíře, komíny a obdobné svislé konstrukce.',
            flat_reproduction_price: 'Reprodukční cena se počítá pro celou stavbu, nelze jí proto stanovit pro konkrétní bytovou jednotku. Pokud potřebujete zjistit cenu bytu pro případ pojištění, využijte našeho výpočtu tržní ceny.'
        }
    },

    custom_area: {
        title: 'Jednotlivé místnosti',
        modal_btn: 'Zadat jednotlivé místnosti',
        remove: 'Smazat',
        add: 'Přidat místnost',
        save: 'Uložit místnosti',
        close: 'Zavřít',
        types: {
            kitchen: 'Kuchyň',
            living_room: 'Obývací pokoj',
            kitchen_w_living_room: 'Kuchyň s obývacím pokojem',
            bedroom: 'Ložnice',
            children_room: 'Dětský pokoj',
            bathroom: 'Koupelna',
            toilet: 'Toaleta',
            hallway: 'Chodba',
            gallery: 'Galerie',
            dressing_room: 'Šatna',
            other: 'Jiná místnost',
            flat_technical_room: 'Technická místnost v bytě',
            technical_room: 'Technická místnost',
            workshop: 'Dílna',
            uninhabited_attic: 'Neobytné podkroví',
        }
    },

    reproduction: {
        flat_price: 'Reprodukční cena bytu',
        find_price: 'Zjistit tržní cenu',
        market_price: 'Výpočet tržní ceny',
        reproduction_price: 'Výpočet reprodukční ceny',
    },

    prepositions: {
        of: 'z',
        in: 'v',
        from: 'od',
        to: 'do',
    },

    result: '0 výsledků | {n} výsledek | {n} výsledky | {n} výsledků',

    record_search: {
        btn: 'Vybrat dle parametrů',
        modal_title: 'Výběr parametrů a nemovitostí',
        search_results_count: 'Nalezeno více, než {n} výsledků. Zpřesněte výběr.',
        btn_back: 'Zpět na výběr parametrů',
        table: {
            area: 'Plocha',
            price: 'Cena',
            pairing_status: 'Párování na prodej',
        }
    },

    coefficients: {
        valued: 'Oceňovaná nemovitost',
        comparable: 'Srovnávaná nemovitost',
        better: 'Lepší',
        same: 'Stejné',
        title_valued: 'Ocěňovaná nemovitost je lepší',
        title_comparable: 'Srovnávaná nemovitost je lepší',
        difference: 'Rozdíl',
        delete_custom_coef: 'Smazat položku',
        create_custom_coef: 'Přidat další položku',
        edit_advertised_price: 'Úprava inzerované ceny',
        original_price: 'Původní cena',
        final_price: 'Výsledná úprava ceny',
        edit_price: 'Upravená cena',
    },
}
